// extracted by mini-css-extract-plugin
module.exports = {"base":"ProjectLogo-module-base"};